module.exports = __webpack_public_path__ + "static/media/yelp-review.a72f10a7.png";